export default __webpack_public_path__ + "static/media/viberlink-white.bba65279.png";